import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

export const selectedAttachmentsIdsSelector = (state: AppState): ID[] =>
  state.canvas.attachments
